module.exports = {"510108002":"猛追湾街道","510108004":"双桥子街道","510108005":"建设路街道","510108006":"府青路街道","510108007":"二仙桥街道","510108008":"跳蹬河街道","510108010":"双水碾街道","510108011":"万年场街道","510108012":"桃蹊路街道","510108013":"圣灯街道","510108014":"保和街道","510108015":"青龙街道","510108016":"龙潭街道","510108017":"白莲池街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510108.json
// module id = 2257
// module chunks = 0